import { type ReactNode } from 'react';
import { LocaleSwitcher } from 'receivable-invoices-js/react/components/shared/locale-switcher';
import { QontoHeader } from 'receivable-invoices-js/react/components/shared/qonto-header';
import { useMedia } from 'receivable-invoices-js/react/hooks/use-media';
import { ClientPortalButton } from 'receivable-invoices-js/react/components/shared/responsive-view/client-portal-button';
import styles from '../responsive-view.module.css';

interface DocumentHeaderProps {
  isClientPortalEnabled?: boolean;
  clientPortalId?: string;
}

export function DocumentHeader({
  isClientPortalEnabled,
  clientPortalId,
}: DocumentHeaderProps): ReactNode {
  const { isMobile } = useMedia();
  return (
    <div className={styles.header} role={!isMobile ? 'banner' : undefined}>
      <QontoHeader className={styles.qontoHeader} data-testid="qonto-header" />
      <div className={styles.headerInner}>
        <LocaleSwitcher data-testid="locale-switcher" />
        {isClientPortalEnabled && !isMobile ? (
          <ClientPortalButton clientPortalId={clientPortalId} />
        ) : null}
      </div>
    </div>
  );
}
